"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.WIFI_TYPES = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _localization = require("@lt/localization");

var _HotelCardFact = _interopRequireDefault(require("./HotelCardFact"));

var _WifiFree = _interopRequireDefault(require("../../icons-react/hotel-facts/WifiFree"));

var _WifiPaid = _interopRequireDefault(require("../../icons-react/hotel-facts/WifiPaid"));

var _WifiLobbyFree = _interopRequireDefault(require("../../icons-react/hotel-facts/WifiLobbyFree"));

var _WifiLobbyPaid = _interopRequireDefault(require("../../icons-react/hotel-facts/WifiLobbyPaid"));

var WIFI_TYPES = {
  FREE: {
    tooltip: _localization.i18n.t('hotelcard.facts.wifi.free'),
    icon: /*#__PURE__*/_react["default"].createElement(_WifiFree["default"], null),
    label: _localization.i18n.t('hotelcard.facts.wifi.everywhere')
  },
  LOBBY_FREE: {
    tooltip: _localization.i18n.t('hotelcard.facts.wifi.lobby_free'),
    icon: /*#__PURE__*/_react["default"].createElement(_WifiLobbyFree["default"], null),
    label: _localization.i18n.t('hotelcard.facts.wifi.lobby')
  },
  PAID: {
    tooltip: _localization.i18n.t('hotelcard.facts.wifi.paid'),
    icon: /*#__PURE__*/_react["default"].createElement(_WifiPaid["default"], null),
    label: _localization.i18n.t('hotelcard.facts.wifi.paid_label')
  },
  LOBBY_PAID: {
    tooltip: _localization.i18n.t('hotelcard.facts.wifi.lobby_paid'),
    icon: /*#__PURE__*/_react["default"].createElement(_WifiLobbyPaid["default"], null),
    label: _localization.i18n.t('hotelcard.facts.wifi.lobby')
  },
  LOBBY_UNKNOWN: {
    tooltip: _localization.i18n.t('hotelcard.facts.wifi.lobby_unknown'),
    icon: /*#__PURE__*/_react["default"].createElement(_WifiLobbyFree["default"], null),
    label: _localization.i18n.t('hotelcard.facts.wifi.lobby')
  }
};
exports.WIFI_TYPES = WIFI_TYPES;

var HotelWiFiType = function HotelWiFiType(_ref) {
  var value = _ref.value,
      className = _ref.className;
  var wifiType = WIFI_TYPES[value && value.toUpperCase()];

  if (!wifiType) {
    return null;
  }

  var icon = wifiType.icon,
      label = wifiType.label,
      tooltip = wifiType.tooltip;
  return /*#__PURE__*/_react["default"].createElement(_HotelCardFact["default"], {
    className: className,
    label: label,
    tooltip: tooltip,
    icon: icon
  });
};

HotelWiFiType.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].string.isRequired
};
HotelWiFiType.defaultProps = {
  className: ''
};

var _default = /*#__PURE__*/_react["default"].memo(HotelWiFiType);

exports["default"] = _default;